/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoGroupingComponent extends NestedOption {
    
    get allowCollapsing(): boolean {
        return this._getOption('allowCollapsing');
    }
    set allowCollapsing(value: boolean) {
        this._setOption('allowCollapsing', value);
    }

    
    get autoExpandAll(): boolean {
        return this._getOption('autoExpandAll');
    }
    set autoExpandAll(value: boolean) {
        this._setOption('autoExpandAll', value);
    }

    
    get contextMenuEnabled(): boolean {
        return this._getOption('contextMenuEnabled');
    }
    set contextMenuEnabled(value: boolean) {
        this._setOption('contextMenuEnabled', value);
    }

    
    get expandMode(): string {
        return this._getOption('expandMode');
    }
    set expandMode(value: string) {
        this._setOption('expandMode', value);
    }

    
    get groupContinuedMessage(): any {
        return this._getOption('groupContinuedMessage');
    }
    set groupContinuedMessage(value: any) {
        this._setOption('groupContinuedMessage', value);
    }

    
    get groupContinuesMessage(): any {
        return this._getOption('groupContinuesMessage');
    }
    set groupContinuesMessage(value: any) {
        this._setOption('groupContinuesMessage', value);
    }

    
    get texts(): any {
        return this._getOption('texts');
    }
    set texts(value: any) {
        this._setOption('texts', value);
    }

    protected get _optionPath() {
        return 'grouping';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-grouping',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowCollapsing': [{ type: Input },],
'autoExpandAll': [{ type: Input },],
'contextMenuEnabled': [{ type: Input },],
'expandMode': [{ type: Input },],
'groupContinuedMessage': [{ type: Input },],
'groupContinuesMessage': [{ type: Input },],
'texts': [{ type: Input },],
};
}


export class DxoGroupingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoGroupingComponent
  ],
  exports: [
    DxoGroupingComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
